import React from 'react';
import { Typography, Alert, Box } from '@mui/material'
import { isMobile } from '../../Utilities/isMobile';
import SelectedStore from '../SelectedStore';
import SelectedYearMonth from '../SelectedYearMonth';

const PageWithTitleLayout = ({ title, message, setMessage, children, style, disableStoreSelect=false, disableMonthYearSelect=false, titleOnly=false }) => {
    return (
    <div className="whole-contents">
        <div style={{ ...style, marginBottom: '3rem', minHeight: !isMobile() && 'calc(100vh - 56px)', display: 'flex', flexDirection: 'column' }}>
            {isMobile() && title.length > 0 ?
                <div className="title-bar">
                    {titleOnly && <Typography variant="h6" component="div"  margin="1rem" sx={{ width: '50%', marginLeft: "2rem", marginRight: "auto"}}>{title}</Typography>}
                    {!titleOnly && <SelectedStore disabled={disableStoreSelect} />}
                    {!titleOnly && <SelectedYearMonth disabled={disableMonthYearSelect}/>}
                </div> :
                <Box sx={{ borderBottom: '1px solid lightgray', display: 'flex', alignItems: 'center', justifyContent: 'end', width: '100%' }}>
                    <Typography variant="h6" component="div"  margin="1rem" sx={{ width: '50%', marginLeft: "2rem", marginRight: "auto"}}>
                        {title}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '50%' }}>
                        {!titleOnly && <SelectedYearMonth disabled={disableMonthYearSelect}/>}
                        {!titleOnly && <SelectedStore disabled={disableStoreSelect} />}
                    </Box>
                </Box>
            }
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                {message?.length > 0 && (
                    <Alert
                        style={{ width: '390px', alignSelf: 'center' }}
                        onClose={() => setMessage('')}
                        severity="error"
                    >
                        {message}
                    </Alert>
                )}
            </div>
            {children}
        </div>
    </div>
)}

export default PageWithTitleLayout
